import { Column, Entity } from 'typeorm'
import { BaseEntity } from '../entity'

@Entity()
export class TableToken extends BaseEntity<TableToken> {
	@Column({
		type: 'text',
		nullable: false,
		unique: true,
		default: () => "substr(md5(''||now()::text||random()::text), 0, 16)",
	})
	token: string

	@Column({
		type: 'uuid',
		nullable: false,
		unique: true,
	})
	tableId: string
}
